import React, { forwardRef, useEffect, useState } from 'react';
import QRCodeLib from 'qrcode';
import Logger from '@medflex/utils/Logger';

import * as PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

const QRCode = forwardRef((props, ref) => {
  const { value, className, children, dataComponent, ...rest } = props;
  const cn = useClassNames(() => [className]);
  const [url, setUrl] = useState('');

  const loadUri = async text => {
    try {
      const uri = await QRCodeLib.toDataURL(text, rest);
      setUrl(uri);
    } catch (e) {
      Logger.warn(`Can not execute QRCodeLib.toDataURL: ${e}`);
    }
  };

  useEffect(() => {
    loadUri(value);
  }, [value]);

  return (
    <div data-component={dataComponent} className={cn}>
      {/* copy save zone */}
      <div ref={ref}>
        <img src={url} alt={value} />
      </div>
      {children}
    </div>
  );
});

QRCode.displayName = 'QRCode';

QRCode.propTypes = {
  value: PropTypes.string.isRequired,
  dataComponent: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
};

QRCode.defaultProps = {};

export default QRCode;
